import PricingCard from "./PricingCard";

const PricingRow = ({ plans = [] }) => {
  if (!plans.length) return null;

  // Logic to keep Weekly plan first
  const weeklyPlan = plans.find(p => p.days === "Weekly");
  const otherPlans = plans.filter(p => p.days !== "Weekly");
  const orderedPlans = [weeklyPlan, ...otherPlans].filter(Boolean);

  return (
    /* Changed grid to flex flex-wrap justify-center */
    <div className="flex flex-wrap justify-center gap-8 w-full">
      {orderedPlans.map((plan, index) => (
        <div key={index} className="w-full sm:w-[calc(50%-2rem)] lg:w-[calc(33.333%-2rem)] max-w-[400px]">
          <PricingCard plan={plan} />
        </div>
      ))}
    </div>
  );
};

export default PricingRow;